import React from 'react';

import { withDocumentTitle } from '../generic/DocumentTitle';
import add from '../REST/add';
import api from '../REST/api';
import { tapFlashSuccess } from '../utils/flash';
import BrandForm from './BrandForm';
import {
  transformForPatch,
  transformForRendering,
} from './transform-brand-helpers';

const AddBrand = add({
  default: {
    accountIds: [],
    name: '',
    code: '',
    created: '',
    lastModified: '',
    createdBy: '',
    lastModifiedBy: '',
    isBrandGroup: false,
  },
  update: (props, changedModel) =>
    api
      .addBrand({
        data: transformForPatch(changedModel),
      })
      .then(transformForRendering)
      .then(tapFlashSuccess('Created Brand')),
  form: props => <BrandForm newModel {...props} />,
  redirectTo: '/brands/:id/show',
});

export default withDocumentTitle('Create Brand')(AddBrand);
